import store from 'store'

type StorageKey = 'authToken' | 'labelTraceScans' | 'packTraceSession' | 'customLabelSearch' | 
'customLabelPage' | 'customLabelLimit' | 'isLabelBuilder' | 'systemLabelSearch' | 'inTrial'

export default {
  get (key: StorageKey) {
    return store.get(key)
  },

  set (key: StorageKey, value: any) {
    store.set(key, value)
  },

  remove (key: StorageKey) {
    store.remove(key)
  },

  getWithId (key: StorageKey, id: string) {
    const newKey = key + "_" + id
    return store.get(newKey)
  },

  setWithId (key: StorageKey, id: string, value: any) {
    const newKey = key + "_" + id
    store.set(newKey, value)
  },

  removeWithId (key: StorageKey, id: string) {
    const newKey = key + "_" + id
    store.remove(newKey)
  }
}
